// eslint-disable-next-line import/prefer-default-export
export enum GatewayCreationStep {
  ADD_WIFI_CREDENTIALS = 1,
  NAME_GATEWAYS = 2,
}
